<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="800"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="删除Profile"
      @ok="handleSubmit"
    >
      <a-row>
        <a-form class="simiot-compact-form" :form="form" @submit="handleSubmit">
          <a-col :span="24">
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-textarea
                :rows="15"
                :placeholder="iccidPlaceholder"
                :style="{ color: iccidValidateStatus === 'error' ? 'red' : '' }"
                v-model.trim="iccidInput"
                @blur="analyzeIccidInput"
              />
            </a-form-item>
            <a-form-item label="ICCID总数" :style="{ display: 'inline-block', width: '50%' }">
              <span>{{ iccidsCount }}</span>
            </a-form-item>
            <a-form-item label="重复数量" :style="{ display: 'inline-block', width: '50%' }">
              <span>{{ duplicateIccidsCount }}</span>
            </a-form-item>
            <div v-if="iccidErrorMsg" style="color: red">{{ iccidErrorMsg }}</div>
          </a-col>
          <a-col :span="24">
            <a-form-item label="备注">
              <a-textarea
                v-decorator="['remark', { rules: [{ max: 200, message: '最多200个字符' }] }]"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { destroyProfileInventories } from '@/api/profile_inventory'
import { analyzeIccids, maxIccidLines } from '@/utils/iccid'

export default {
  name: 'BatchOperationsDestroyProfileInventory',
  props: {
    visible: { type: Boolean, required: true },
    iccids: { type: Array, default() { return [] } }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'destroy_profile_inventory' }),
      submitting: false,
      iccidInput: (this.iccids || []).join('\n'),
      parsedIccids: [],
      iccidsCount: 0,
      duplicateIccidsCount: 0,
      iccidValidateStatus: '',
      iccidErrorMsg: '',
      iccidPlaceholder: '可以直接复制excel中整列ICCID；\n' +
        '手动输入多个ICCID，一行一个。'
    }
  },
  computed: {
    isShow: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  created() {
    if (this.iccidInput) {
      this.analyzeIccidInput()
    }
  },
  methods: {
    analyzeIccidInput() {
      if (!this.iccidInput) {
        this.parsedIccids = []
        this.iccidsCount = 0
        this.duplicateIccidsCount = 0
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = '请输入 ICCID'
        return
      }

      const { lines, validIccids, errorText } = analyzeIccids(this.iccidInput)
      if (lines > maxIccidLines) {
        this.parsedIccids = []
        this.iccidsCount = 0
        this.duplicateIccidsCount = 0
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = `ICCID数量不能超过${maxIccidLines}`
        return
      }

      this.iccidInput = errorText + validIccids.join('\n')
      this.parsedIccids = this.$lodash.uniq(validIccids)
      this.iccidsCount = validIccids.length
      this.duplicateIccidsCount = validIccids.length - this.parsedIccids.length

      if (errorText) {
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = '号码包含错误，无法提交'
      } else if (this.parsedIccids.length === 0) {
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = '请输入 ICCID'
      } else if (this.duplicateIccidsCount > 0) {
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = '录入的 ICCID 存在重复'
      } else {
        this.iccidValidateStatus = 'success'
        this.iccidErrorMsg = ''
      }
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }
      this.analyzeIccidInput()
      if (this.iccidValidateStatus === 'error') {
        return
      }
      this.form.validateFields((err, values) => {
        if (err) return
        this.submitting = true
        destroyProfileInventories({ iccids: this.parsedIccids, remark: values.remark || '' }).then((res) => {
          if (res.code === 0) {
            this.isShow = false
            this.$emit('completed')
            this.$success({
              title: '提交成功',
              content: (<div><p>删除任务已提交，请在批量操作查询中查看结果</p></div>)
            })
          }
          this.submitting = false
        }).catch(() => { this.submitting = false })
      })
    }
  }
}
</script>
